export default __webpack_public_path__ + "static/media/Flag_of_Netherlands.398702d5.svg";